var _clipPath, _use, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _ellipse, _ellipse2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultKortti(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 228 326",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M161.534,56.199c0,0 2.324,1.55 7.376,0.622c5.052,-0.928 8.356,-5.69 8.356,-5.69l-10.759,-4.176l-4.973,9.244Z",
    style: {
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.089,57.739l-4.766,-11.141l-10.45,0.775l4.65,15.862l10.566,-5.496Z",
    style: {
      fill: "#ffc98c",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.261,43.196c0.79,0.86 1.54,1.803 2.251,2.827c1.955,2.815 3.616,6.233 5.022,10.176c2.231,-3.289 7.027,-4.484 7.027,-4.484l-1.763,-3.795l4.225,3.211c0,0 3.958,-1.149 6.243,0c-1.361,-2.799 -3.44,-5.897 -4.066,-9.809l-18.939,1.874Z",
    style: {
      fill: "#ffe449",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.06,46.741l-131.807,-7.48c-7.386,-0.386 -15.492,1.917 -25.333,10.458c-6.243,5.419 -13.378,10.237 -22.285,10.237c-11.6,0 -21.64,-6.734 -26.419,-16.504l28.92,0l7.712,-13.358l-7.712,-13.359l-28.437,0c4.95,-9.257 14.713,-15.561 25.936,-15.561c8.339,0 14.957,4.53 21.223,9.067c8.321,6.026 14.297,10.823 26.613,11.446l132.353,1.193c0.058,0 0.115,0.001 0.173,0.003c0.058,-0.001 0.116,-0.001 0.175,-0.001c6.598,0 11.955,5.357 11.955,11.955c0,6.599 -5.357,11.956 -11.955,11.956l-0.051,-0.001c-0.099,0.007 -0.197,0.011 -0.297,0.011l-0.478,-0.039c-0.096,-0.006 -0.191,-0.014 -0.286,-0.023Zm0.063,-20.02c4.48,0 8.117,3.637 8.117,8.116c0,4.48 -3.637,8.117 -8.117,8.117c-4.48,0 -8.117,-3.637 -8.117,-8.117c0,-4.479 3.637,-8.116 8.117,-8.116Z",
    style: {
      fill: "#aaa"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.06,46.741l-131.807,-7.48c-7.386,-0.386 -15.492,1.917 -25.333,10.458c-6.243,5.419 -13.378,10.237 -22.285,10.237c-11.6,0 -21.64,-6.734 -26.419,-16.504l28.92,0l7.712,-13.358l-7.712,-13.359l-28.437,0c4.95,-9.257 14.713,-15.561 25.936,-15.561c8.339,0 14.957,4.53 21.223,9.067c8.321,6.026 14.297,10.823 26.613,11.446l132.353,1.193c0.058,0 0.115,0.001 0.173,0.003c0.058,-0.001 0.116,-0.001 0.175,-0.001c6.598,0 11.955,5.357 11.955,11.955c0,6.599 -5.357,11.956 -11.955,11.956l-0.051,-0.001c-0.099,0.007 -0.197,0.011 -0.297,0.011l-0.478,-0.039c-0.096,-0.006 -0.191,-0.014 -0.286,-0.023Zm0.063,-20.02c4.48,0 8.117,3.637 8.117,8.116c0,4.48 -3.637,8.117 -8.117,8.117c-4.48,0 -8.117,-3.637 -8.117,-8.117c0,-4.479 3.637,-8.116 8.117,-8.116Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.437,
    cy: 55.557,
    r: 10.302,
    style: {
      fill: "#4a4b4e"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.788,
    cy: 58.121,
    r: 4.768,
    style: {
      fill: "#4a4b4e"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.9,
    cy: 51.426,
    r: 1.928,
    style: {
      fill: "#4a4b4e"
    }
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image2",
    x: 12.922,
    y: 22.424,
    width: "30.198px",
    height: "29.795px",
    transform: "matrix(0.974136,0,0,0.993162,-9.09495e-13,1.73372e-12)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 42.87,
    cy: 4.992,
    r: 11.315,
    style: {
      fill: "#4a4b4e"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137.42,
    cy: 44.481,
    r: 11.315,
    style: {
      fill: "#4a4b4e"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.08,
    cy: 25.747,
    r: 11.315,
    style: {
      fill: "#4a4b4e"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181.61,
    cy: 35.97,
    r: 5.337,
    style: {
      fill: "#4a4b4e"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.398,
    cy: 23.223,
    r: 5.337,
    style: {
      fill: "#4a4b4e"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.421,
    cy: 30.114,
    r: 2.221,
    style: {
      fill: "#4a4b4e"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.556,
    cy: 37.685,
    r: 7.57,
    style: {
      fill: "#4a4b4e"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.025,
    cy: 30.633,
    r: 4.312,
    style: {
      fill: "#4a4b4e"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.187,
    cy: 21.553,
    r: 4.768,
    style: {
      fill: "#4a4b4e"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.419,
    cy: 20.578,
    r: 2.692,
    style: {
      fill: "#4a4b4e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.584,28.906c-1.586,1.482 -2.578,3.592 -2.578,5.931c0,2.233 0.903,4.256 2.364,5.724l-142.696,-7.093c1.58,-2.301 1.53,-4.548 0.095,-6.747l142.815,2.185Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M207.06,46.741l-131.807,-7.48c-7.386,-0.386 -15.492,1.917 -25.333,10.458c-6.243,5.419 -13.378,10.237 -22.285,10.237c-11.6,0 -21.64,-6.734 -26.419,-16.504l28.92,0l7.712,-13.358l-7.712,-13.359l-28.437,0c4.95,-9.257 14.713,-15.561 25.936,-15.561c8.339,0 14.957,4.53 21.223,9.067c8.321,6.026 14.297,10.823 26.613,11.446l132.353,1.193c0.058,0 0.115,0.001 0.173,0.003c0.058,-0.001 0.116,-0.001 0.175,-0.001c6.598,0 11.955,5.357 11.955,11.955c0,6.599 -5.357,11.956 -11.955,11.956l-0.051,-0.001c-0.099,0.007 -0.197,0.011 -0.297,0.011l-0.478,-0.039c-0.096,-0.006 -0.191,-0.014 -0.286,-0.023Zm0.063,-20.02c4.48,0 8.117,3.637 8.117,8.116c0,4.48 -3.637,8.117 -8.117,8.117c-4.48,0 -8.117,-3.637 -8.117,-8.117c0,-4.479 3.637,-8.116 8.117,-8.116Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.816,115.082c0,0 -3.659,56.513 4.13,68.414c2.782,4.25 8.252,2.235 4.381,-5.505c-3.093,-6.184 -4.628,-62.909 -4.628,-62.909l-3.883,0Z",
    style: {
      fill: "#4a4b4e",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.935,169.735c-0.5,8.178 -46.491,17.861 -47.114,9.759l42.646,-17.357l4.468,7.598Z",
    style: {
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.989,229.024l-10.817,8.864l16.131,19.683l10.817,-8.865l-16.131,-19.682Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.025,167.554l-34.313,5.554l-2.983,9.732c-17.339,-3.894 -39.412,6.927 -40.748,17.487c-2.095,16.554 31.896,42.769 31.896,42.769l16.947,-8.92l-17.226,-24.057c4.193,-4.917 16.249,5.652 31.392,-3.004c12.539,5.512 29.026,-4.072 29.026,-4.072l10.117,15.685c0,0 28.139,-14.389 25.322,-32.562c-2.414,-15.576 -32.143,-16.075 -48.217,-6.987l-1.213,-11.625Z",
    style: {
      fill: "#2248f6"
    }
  }), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.025,167.554l-34.313,5.554l-2.983,9.732c-17.339,-3.894 -39.412,6.927 -40.748,17.487c-2.095,16.554 31.896,42.769 31.896,42.769l16.947,-8.92l-17.226,-24.057c4.193,-4.917 16.249,5.652 31.392,-3.004c12.539,5.512 29.026,-4.072 29.026,-4.072l10.117,15.685c0,0 28.139,-14.389 25.322,-32.562c-2.414,-15.576 -32.143,-16.075 -48.217,-6.987l-1.213,-11.625Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.625,190.19c1.556,1.076 3.442,1.567 5.326,1.386c4.412,-0.422 7.646,-4.341 7.224,-8.753",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2,
      strokeLinejoin: "miter"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.833,185.926c-1.324,1.351 -3.083,2.191 -4.966,2.371c-4.412,0.422 -8.331,-2.812 -8.753,-7.224",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2,
      strokeLinejoin: "miter"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.033,188.364c6.842,0.499 11.935,7.237 11.365,15.037c-0.569,7.8 -6.587,13.727 -13.43,13.227c-6.842,-0.5 -11.935,-7.238 -11.365,-15.038c0.569,-7.8 6.587,-13.726 13.43,-13.226Z",
    style: {
      fill: "#90a0e8",
      stroke: "#000",
      strokeWidth: 2,
      strokeDasharray: "2,4,0,0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.403,170.649c5.894,-3.511 13.929,-0.906 17.931,5.813c4.001,6.719 2.465,15.025 -3.43,18.535c-5.894,3.511 -13.929,0.906 -17.931,-5.813c-4.001,-6.719 -2.465,-15.024 3.43,-18.535Z",
    style: {
      fill: "#90a0e8",
      stroke: "#000",
      strokeWidth: 2,
      strokeDasharray: "2,4,0,0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M151.025,167.554l-34.313,5.554l-2.983,9.732c-17.339,-3.894 -39.412,6.927 -40.748,17.487c-2.095,16.554 31.896,42.769 31.896,42.769l16.947,-8.92l-17.226,-24.057c4.193,-4.917 16.249,5.652 31.392,-3.004c12.539,5.512 29.026,-4.072 29.026,-4.072l10.117,15.685c0,0 28.139,-14.389 25.322,-32.562c-2.414,-15.576 -32.143,-16.075 -48.217,-6.987l-1.213,-11.625Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.876,246.852l-16.194,13.315l-19.749,25.161c2.15,3.077 4.226,3.846 7.297,3.252c2.818,-0.545 8.128,-4.2 12.222,-7.24c5.752,-4.272 11.161,-10.724 13.983,-15.956l-0.414,-1.783l1.942,-0.067c4.249,-2.621 6.761,-6.007 8.739,-9.63l-7.826,-7.052Z",
    style: {
      fill: "#616161",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.067,286.595c-4.528,-4.081 -0.656,-8.705 3.825,-11.658c1.082,-0.713 2.598,-1.724 2.879,-2.602c1.917,-5.977 6.018,-21.491 6.018,-21.491c5.641,-0.237 15.864,-2.507 10.594,-9.138c0,0 2.342,-3.099 6.82,0.936l5.662,5.102c0,0 -5.61,0.286 -9.078,10.034c-1.558,4.38 -6.773,15.859 -12.067,20.543c-6.635,5.871 -13.762,9.076 -14.653,8.274Z",
    style: {
      fill: "#c5c5c5"
    }
  }), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.067,286.595c-4.528,-4.081 -0.656,-8.705 3.825,-11.658c1.082,-0.713 2.598,-1.724 2.879,-2.602c1.917,-5.977 6.018,-21.491 6.018,-21.491c5.641,-0.237 15.864,-2.507 10.594,-9.138c0,0 2.342,-3.099 6.82,0.936l5.662,5.102c0,0 -5.61,0.286 -9.078,10.034c-1.558,4.38 -6.773,15.859 -12.067,20.543c-6.635,5.871 -13.762,9.076 -14.653,8.274Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.148,224.385c5.34,-5.926 13.753,-7.063 18.775,-2.537c5.023,4.526 4.765,13.011 -0.574,18.937c-5.34,5.926 -13.753,7.063 -18.775,2.537c-5.023,-4.525 -4.766,-13.011 0.574,-18.937Z",
    style: {
      fill: "#2248f6",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.57,279.926c3.637,4.326 15.957,-10.933 19.791,-6.037l3.226,6.187l-23.13,19.447l-9.606,-11.425l9.719,-8.172Z",
    style: {
      fill: "#4c4f5d",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.275,268.442l-4.737,-0.114l7.345,-6.559l-6.077,-0.409l8.685,-6.264l-7.601,-0.58",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.067,286.595c-4.528,-4.081 -0.656,-8.705 3.825,-11.658c1.082,-0.713 2.598,-1.724 2.879,-2.602c1.917,-5.977 6.018,-21.491 6.018,-21.491c5.641,-0.237 15.864,-2.507 10.594,-9.138c0,0 2.342,-3.099 6.82,0.936l5.662,5.102c0,0 -5.61,0.286 -9.078,10.034c-1.558,4.38 -6.773,15.859 -12.067,20.543c-6.635,5.871 -13.762,9.076 -14.653,8.274Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.738,228.375c-4.462,6.166 -10.475,10.904 -17.561,14.652l6.065,7.268c7.377,-3.156 13.186,-8.091 17.56,-14.652l-6.064,-7.268Z",
    style: {
      fill: "#90a0e8",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.598,210.119c-1.92,-2.49 -0.658,-4.659 0.953,-4.721",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.882,200.928l5.215,-9.812",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.36,204.694c0,0 -3.643,3.502 4.111,12.248c5.266,5.939 12.771,6.942 12.771,6.942l5.315,-6.524l-14.354,-14.462l-7.843,1.796Z",
    style: {
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.088,204.587l9.007,9.318l-14.976,14.474l-9.006,-9.318l14.975,-14.474Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.346,216.484l14.203,15.421l12.532,29.796c-2.783,2.194 -5.805,1.946 -5.805,1.946l-20.809,-28.014l0.396,-2.166l-2.304,-0.829l-8.226,-9.177l10.013,-6.977Z",
    style: {
      fill: "#616161",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.081,261.701c6.062,-4.104 -1.465,-10.781 -2.413,-16.102c-1.093,-6.125 -4.14,-20.653 -4.14,-20.653c-3.648,-5.388 -16.196,-6.01 -7.485,-11.057c0,0 -2.497,-4.309 -7.489,-0.93l-6.311,4.272c0,0 7.344,2.203 8.236,12.511c0.85,9.827 15.411,21.952 19.602,31.959Z",
    style: {
      fill: "#c5c5c5"
    }
  }), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.081,261.701c6.062,-4.104 -1.465,-10.781 -2.413,-16.102c-1.093,-6.125 -4.14,-20.653 -4.14,-20.653c-3.648,-5.388 -16.196,-6.01 -7.485,-11.057c0,0 -2.497,-4.309 -7.489,-0.93l-6.311,4.272c0,0 7.344,2.203 8.236,12.511c0.85,9.827 15.411,21.952 19.602,31.959Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.021,196.401c-4.472,-6.606 -12.648,-8.892 -18.246,-5.102c-5.599,3.79 -6.514,12.23 -2.042,18.836c4.471,6.605 12.647,8.891 18.246,5.101c5.598,-3.79 6.513,-12.229 2.042,-18.835Z",
    style: {
      fill: "#2248f6",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.549,240.551l-4.253,1.616l4.088,-8.764l-5.554,1.829l5.389,-8.977l-6.972,2.224",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.972,246.653c0,0 2.955,-2.423 7.017,1.528c3.712,3.611 9.65,9.387 9.65,9.387l-0.872,5.376c0,0 -8.181,2.207 -8.678,1.171c-0.498,-1.035 -7.117,-17.462 -7.117,-17.462",
    style: {
      fill: "#4c4f5d",
      stroke: "#000",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170.081,261.701c6.062,-4.104 -1.465,-10.781 -2.413,-16.102c-1.093,-6.125 -4.14,-20.653 -4.14,-20.653c-3.648,-5.388 -16.196,-6.01 -7.485,-11.057c0,0 -2.497,-4.309 -7.489,-0.93l-6.311,4.272c0,0 7.344,2.203 8.236,12.511c0.85,9.827 15.411,21.952 19.602,31.959Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.328,198.496c9.372,2.496 17.054,11.854 16.987,19.096l-7.073,6.292c1.725,-8.205 -12.568,-20 -16.987,-19.097l7.073,-6.291Z",
    style: {
      fill: "#90a0e8",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.34,223.494c1.174,-0.916 9.138,7.323 17.773,18.387c8.635,11.065 14.693,20.791 13.518,21.708c-1.174,0.916 -9.138,-7.323 -17.773,-18.387c-8.635,-11.065 -14.692,-20.792 -13.518,-21.708Z",
    style: {
      fill: "#4c4c4c",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.722,182.845c9.995,-6.465 25.5,-7.97 38.516,-3.666l2.633,-14.81l-41.149,5.366l0,13.11Z",
    style: {
      fill: "#ffc98c",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.924,51.131c0,0 -1.437,2.513 1.878,4.127c3.176,1.547 11.612,3.779 12.655,0.518l-14.533,-4.645Z",
    style: {
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.781,63.001l4.394,-16.403l10.45,0.775l-5.924,19.875l-8.92,-4.247Z",
    style: {
      fill: "#ffc98c",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.238,43.196c-3.199,3.196 -5.901,7.208 -7.762,12.602c-1.769,-2.02 -4.404,-2.783 -4.404,-2.783l-1.419,-5.095l-1.43,4.365c0,0 -6.113,-3.011 -7.299,-1.154c1.99,-3.116 3.537,-6.311 3.374,-9.809l18.94,1.874Z",
    style: {
      fill: "#ffe449",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.935,169.735c-10.096,-2.898 -38.204,-0.479 -47.114,9.759c0.5,-9.984 -0.025,-25.04 -4.601,-36.162c0,0 -12.352,-21.542 -13.047,-43.267c-0.572,-17.869 1.751,-39.708 1.751,-39.708c0.753,-2.907 10.739,0.132 10.893,2.794c1.008,27.431 -2.076,65.542 23.773,65.494c29.151,-0.053 32.406,-66.274 32.406,-66.274c-0.431,-2.858 11.124,-8.35 12.089,-5.448c0,0 0.24,28.503 -2.662,42.888c-2.81,13.93 -16.109,40.668 -16.109,40.668l2.621,29.256Z",
    style: {
      fill: "#fff"
    }
  }), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.935,169.735c-10.096,-2.898 -38.204,-0.479 -47.114,9.759c0.5,-9.984 -0.025,-25.04 -4.601,-36.162c0,0 -12.352,-21.542 -13.047,-43.267c-0.572,-17.869 1.751,-39.708 1.751,-39.708c0.753,-2.907 10.739,0.132 10.893,2.794c1.008,27.431 -2.076,65.542 23.773,65.494c29.151,-0.053 32.406,-66.274 32.406,-66.274c-0.431,-2.858 11.124,-8.35 12.089,-5.448c0,0 0.24,28.503 -2.662,42.888c-2.81,13.93 -16.109,40.668 -16.109,40.668l2.621,29.256Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip6)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M226.172,38.692l0,233.656",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.595,38.692l0,233.656",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.018,38.692l0,233.656",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.441,38.692l0,233.656",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.864,38.692l0,233.656",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.287,38.692l0,233.656",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.71,38.692l0,233.656",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.133,38.692l0,233.656",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.556,38.692l0,233.656",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.979,38.692l0,233.656",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.402,38.692l0,233.656",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.825,38.692l0,233.656",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.248,38.692l0,233.656",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.441,38.692l233.462,0",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.441,54.269l233.462,0",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.441,69.846l233.462,0",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.441,85.423l233.462,0",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.441,101l233.462,0",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.441,116.577l233.462,0",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.441,132.154l233.462,0",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.441,147.732l233.462,0",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.441,163.309l233.462,0",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.441,178.886l233.462,0",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.441,194.463l233.462,0",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.441,210.04l233.462,0",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.441,225.617l233.462,0",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.441,241.194l233.462,0",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.441,256.771l233.462,0",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.441,272.348l233.462,0",
    style: {
      fill: "none",
      stroke: "#2248f6",
      strokeWidth: 2
    }
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 132.508,
    cy: 123.455,
    r: 13.921,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.71,122.711l0,47.567",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.559,
    cy: 103.786,
    r: 18.925,
    style: {
      fill: "#2248f6",
      stroke: "#000",
      strokeWidth: 2,
      strokeDasharray: "2,4,0,0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.087,
    cy: 101.546,
    r: 18.925,
    style: {
      fill: "#2248f6",
      stroke: "#000",
      strokeWidth: 2,
      strokeDasharray: "2,4,0,0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M159.935,169.735c-10.096,-2.898 -38.204,-0.479 -47.114,9.759c0.5,-9.984 -0.025,-25.04 -4.601,-36.162c0,0 -12.352,-21.542 -13.047,-43.267c-0.572,-17.869 1.751,-39.708 1.751,-39.708c0.753,-2.907 10.739,0.132 10.893,2.794c1.008,27.431 -2.076,65.542 23.773,65.494c29.151,-0.053 32.406,-66.274 32.406,-66.274c-0.431,-2.858 11.124,-8.35 12.089,-5.448c0,0 0.24,28.503 -2.662,42.888c-2.81,13.93 -16.109,40.668 -16.109,40.668l2.621,29.256Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.195,
    cy: 117.806,
    r: 10.846,
    style: {
      fill: "#ffc98c"
    }
  }), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 131.195,
    cy: 117.806,
    r: 10.846
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip7)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.842,
    cy: 98.05,
    rx: 27.768,
    ry: 13.779,
    style: {
      fill: "#3b3b3b",
      stroke: "#000",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 131.195,
    cy: 117.806,
    r: 10.846,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.845,30.09l-7.713,13.358l-15.425,0l-7.712,-13.358l7.712,-13.359l15.425,0l7.713,13.359Z",
    style: {
      fill: "#7f7f7f",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.36,38.483l-9.881,0l-4.94,-8.557l4.94,-8.558l9.881,0l4.941,8.558l-4.941,8.557",
    style: {
      fill: "none",
      stroke: "#636363",
      strokeWidth: 2,
      strokeDasharray: "2,4,0,0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.313,20.416c0.113,-1.246 -0.807,-2.35 -2.053,-2.462c-1.247,-0.113 -2.35,0.807 -2.462,2.054l-0.291,3.214c-0.113,1.246 0.808,2.35 2.054,2.462c1.246,0.113 2.349,-0.807 2.462,-2.054l0.29,-3.214Z",
    style: {
      fill: "#ffe449",
      stroke: "#000",
      strokeWidth: 2
    }
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.43,
    cy: 319.133,
    rx: 46.345,
    ry: 6.146
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.372,
    cy: 319.133,
    rx: 16.612,
    ry: 2.203
  })), /*#__PURE__*/React.createElement("path", {
    d: "M194.688,102.722c-0.069,-9.105 -4.021,-30.266 -2.38,-38.639c1.769,-9.025 5.188,-16.844 7.108,-20.361c5.684,-10.41 8.265,-3.02 6.926,-0.805c-7.875,13.027 -7.336,34.174 -7.336,34.174l13.31,4.013l-4.157,-34.111c2.57,-0.049 4.879,-1.077 7.081,-2.515c3.534,4.35 4.421,40.239 2.805,58.244c-0.39,4.349 1.026,5.783 2.082,15.987c0.722,6.981 -1.631,25.167 0.755,27.408c0,0 4.773,3.956 0.958,9.803l-4.615,-7.457c-3.481,-5.625 -6.162,-17.351 -7.913,-22.829c-0.576,-1.804 -5.018,-1.931 -5.538,-0.295c-1.699,5.341 -3.228,17.396 -6.772,23.124l-5.824,5.129c-3.815,-5.847 2.195,-9.128 2.195,-9.128c2.777,-4.442 -0.767,-18.737 -0.654,-25.755c0.15,-9.354 2.009,-10.618 1.969,-15.987Z",
    style: {
      fill: "#4a4b4e",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.982,75.234c0.772,-10.968 -5.811,-15.278 -5.811,-15.278c-1.194,3.806 -1.969,6.274 -1.969,6.274l-5.2,-0.221c0,0 -1.491,-3.345 -2.697,-6.053c0,0 -3.376,3.499 -4.526,8.924c0,0 -1.555,2.492 -1.578,5.019c-0.059,6.569 4.641,9.992 10.652,10.36c6.01,0.369 10.707,-3.018 11.129,-9.025Z",
    style: {
      fill: "#4a4b4e",
      stroke: "#000",
      strokeWidth: 2
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.926,74.513c-0.195,-1.715 4.163,-2.21 4.358,-0.495c0.194,1.715 -0.624,3.218 -1.827,3.355c-1.202,0.136 -2.337,-1.145 -2.531,-2.86Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M212.735,40.7c-3.152,-5.677 -9.788,4.796 -2.759,3.799c3.38,-0.479 2.759,-3.799 2.759,-3.799Z",
    style: {
      fill: "#4a4b4e",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.137,101.082c0.734,-3.279 -2.696,-9.808 -5.339,-6.923c-3.24,3.535 3.795,4.921 5.339,6.923Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.446,94.539c0,0 5.012,-5.516 2.206,-6.624c-4.142,-1.636 -2.206,6.624 -2.206,6.624Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.799,99.142c0.59,-0.842 5.747,-1.303 4.265,-3.044c-2.622,-3.081 -4.668,1.681 -4.265,3.044Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.17,48.54c0,0 -5.589,-6.804 -2.913,-12.43c1.793,-3.77 5.142,-2.576 10.802,-4.812c0,0 1.195,2.275 -0.263,4.352c-1.558,2.221 -5.911,3.072 -5.911,3.072c5.358,-1.035 7.109,3.671 6.164,6.632",
    style: {
      fill: "#ffe449",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.935,21.722c-0.214,-1.233 -1.388,-2.06 -2.621,-1.846c-1.233,0.213 -2.06,1.388 -1.847,2.621l0.939,5.413c0.214,1.233 1.388,2.061 2.621,1.847c1.233,-0.214 2.06,-1.388 1.846,-2.621l-0.938,-5.414Z",
    style: {
      fill: "#ffe449",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.049,21.328c0.113,-1.246 -0.807,-2.349 -2.053,-2.462c-1.247,-0.112 -2.35,0.808 -2.462,2.054l-0.368,4.069c-0.113,1.246 0.807,2.349 2.054,2.462c1.246,0.112 2.349,-0.808 2.462,-2.054l0.367,-4.069Z",
    style: {
      fill: "#ffe449",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.261,22.181c-0.526,-1.136 -1.875,-1.631 -3.01,-1.105c-1.136,0.525 -1.631,1.874 -1.105,3.009l1.715,3.708c0.526,1.135 1.875,1.631 3.01,1.105c1.136,-0.526 1.631,-1.874 1.105,-3.01l-1.715,-3.707Z",
    style: {
      fill: "#ffe449",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.457,21.512c-0.001,-1.251 1.014,-2.267 2.265,-2.268c1.251,-0.001 2.268,1.014 2.269,2.265l0.004,5.495c0.001,1.251 -1.015,2.268 -2.266,2.268c-1.251,0.001 -2.268,-1.014 -2.269,-2.265l-0.003,-5.495Z",
    style: {
      fill: "#ffe449",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.491,21.77c-0.334,-1.206 0.375,-2.456 1.581,-2.789c1.206,-0.334 2.456,0.375 2.789,1.581l1.089,3.937c0.333,1.206 -0.375,2.456 -1.581,2.789c-1.206,0.334 -2.456,-0.374 -2.789,-1.581l-1.089,-3.937Z",
    style: {
      fill: "#ffe449",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.087,23.375c-0.462,-1.163 0.108,-2.482 1.27,-2.944c1.163,-0.462 2.483,0.107 2.944,1.27l1.192,3c0.462,1.163 -0.107,2.482 -1.27,2.944c-1.163,0.462 -2.482,-0.107 -2.944,-1.27l-1.192,-3Z",
    style: {
      fill: "#ffe449",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.646,21.769c0.27,-1.222 1.481,-1.995 2.703,-1.725c1.222,0.27 1.995,1.481 1.725,2.703l-0.881,3.989c-0.27,1.222 -1.481,1.995 -2.703,1.725c-1.222,-0.27 -1.995,-1.481 -1.725,-2.703l0.881,-3.989Z",
    style: {
      fill: "#ffe449",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.991,46.993c0,0 7.938,-4.85 5.85,-9.561c-1.384,-3.121 -3.344,-2.788 -4.545,-6.867c0,0 -3.174,1.76 -3.529,4.272c-0.351,2.483 1.765,3.945 1.765,3.945c-3.462,-0.55 -6.136,0.617 -7.715,4.172",
    style: {
      fill: "#ffe449",
      stroke: "#000",
      strokeWidth: 2
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "_Image2",
    width: "31px",
    height: "30px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAeCAYAAADU8sWcAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAB/ElEQVRIib2WMWsUQRTHf2OOC0afhQTCGxElWCiCYBpFSxuv0MbiSD6D30ax8RNEUMRGQewi6RRUJKVK4AUJGrhHJAq3Frd3jOfeneZ27lWz+/8Pv/ef3Z1ZyFCqekpV25N8R3LAAQMWVXV55nAz6wJPgTVVDaN8czngAO7eEZHjwJK7f6ny5Fr2fm0ALVVdqBKzJQdw9wMR2QOuufuHYT13coB3QFTVOCxkTQ7g7l0R2QHaIrLp7gNtFskBzgHngZX0ZnZ4jPFECOF2edlW1ebM4MAd4Gg5Pgm0ZgKPMS4D1wFCGOw1LVVdzAqPMQZgrUJqAO2scHqJz6Y3kvSXVfVilk8txrgA3AXmx9hO50p+C5BJptrhMcYI3PgH66Na4eVLtsqIUEVR9Idvzexj3clXgAsTPL+Adahx2WOMTcpPqKqS1C/MbLdWOHCT3g42rr4Bz/sXDVWdB64CZ0IIx6aAXxolJKnXzeznAG5mB6r6GVgtiqKRbAS1VALeAt6k2hyAu++JyC7lkVd3A0AXuGdmnb/gZQPbItKkd/bW0kCS+pWZbQ7rwy/cE+D90MRpqwM8qxL+gJf/2w+BnWkbSOY+NrP9ifCygX3gPvDjsA0kcz4Br0f5Kk81d3cR2QauANM8/Adm9v2/4GUDX0XE6f34HebofWlmG+MMvwHqRqBiC/RF+AAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultKortti);
export default __webpack_public_path__ + "static/media/default_kortti.f6d8e408babc70d2a31713f41430cf29.svg";
export { ForwardRef as ReactComponent };